import { render, staticRenderFns } from "./fourthsecond.vue?vue&type=template&id=61a0b898&"
import script from "./fourthsecond.vue?vue&type=script&lang=js&"
export * from "./fourthsecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a0b898')) {
      api.createRecord('61a0b898', component.options)
    } else {
      api.reload('61a0b898', component.options)
    }
    module.hot.accept("./fourthsecond.vue?vue&type=template&id=61a0b898&", function () {
      api.rerender('61a0b898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/fourth/fourthsecond.vue"
export default component.exports